import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { nextPage, fetchMoreGames } from "../features/catalog/catalogSlice";
import { useTranslation } from "react-i18next";

function BackToTop() {
  const { t, i18n } = useTranslation();

  return (
    <a className="pagination-to-top" href="#">
      <span className="pagination-to-top__title">{t('back-to-top')}</span>
      <div className="pagination-to-top__arrow-up"></div>
    </a>
  );
}

function Pagination() {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const {
    currentPage,
    totalPages,
    gamesLoading,
  } = useSelector((state) => state.catalog);

  const loadMoreGames = useCallback(() => {
    if (gamesLoading) {
      return;
    }

    if (currentPage < totalPages) {
      dispatch(nextPage());
      dispatch(fetchMoreGames({
        page: currentPage + 1,
      }));
    }
  }, [dispatch, gamesLoading, currentPage]);

  return (
    <div className={`pagination__outer ${gamesLoading ? 'is-loading' : ''}`}>
      {currentPage < totalPages &&
        <div className={`load-more-button ${gamesLoading ? 'is-loading' : ''}`} onClick={() => { loadMoreGames() }}>
          <span>{t('show-more-slots')}</span>
          <svg className="load-more-button__icon" width="16" height="21" viewBox="0 0 16 21" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.29289 20.0986C7.68342 20.4891 8.31658 20.4891 8.70711 20.0986L15.0711 13.7346C15.4616 13.3441 15.4616 12.7109 15.0711 12.3204C14.6805 11.9299 14.0474 11.9299 13.6569 12.3204L8 17.9773L2.34315 12.3204C1.95262 11.9299 1.31946 11.9299 0.928932 12.3204C0.538408 12.7109 0.538408 13.3441 0.928932 13.7346L7.29289 20.0986ZM7 0.608887V19.3915H9V0.608887H7Z" />
          </svg>
        </div>
      }
      {currentPage > 1 && <BackToTop />}
    </div>
  )
}

export default Pagination;
